import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserState } from '@app/core/store/states/user/user.state';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { MiraklLoginButtonComponent } from '../mirakl-login-button/mirakl-login-button.component';
import { LoginService } from './login.service';
import { AutofillEvent, CdkAutofill } from '@angular/cdk/text-field';

@Component({
  selector: 'adspt-login-form',
  providers: [LoginService],
  imports: [
    ReactiveFormsModule,
    NzButtonModule,
    NzFormModule,
    NzInputModule,
    NzDividerComponent,
    TranslatePipe,
    MiraklLoginButtonComponent,
    CdkAutofill,
  ],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginFormComponent {
  private fb = inject(FormBuilder);
  private ls = inject(LoginService);
  private translate = inject(TranslateService);
  private cd = inject(ChangeDetectorRef);

  readonly loginSuccess = output<boolean>();

  readonly processing = signal(false);
  readonly user = select(UserState.user);
  readonly form: FormGroup = this.fb.group({
    password: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
  });

  readonly forgotPasswordUrl = computed(
    () => '/portal/request-password-reset?lang=' + (this.translate.currentLang.toLowerCase() || 'en'),
  );

  submitForm(form: FormGroup): void {
    this.processing.set(true);
    this.ls.login(form.value.email, form.value.password).subscribe({
      next: () => {
        this.processing.set(false);
        this.loginSuccess.emit(true);
      },
      error: () => {
        this.processing.set(false);
        this.loginSuccess.emit(false);
      },
    });
  }

  onAutoFill(event: AutofillEvent): void {
    if (event.isAutofilled) {
      setTimeout(() => {
        this.cd.markForCheck();
        document.querySelector('body').click();
      });
    }
  }
}
